import {FC} from "react";
// import {IWorkerData} from "./sidebarContent.type";
import IconStarBlue from "../../../assets/icons/star-blue.svg";
import IconPhoneBlue from "../../../assets/icons/phone-blue.svg";
import IconEmailBlue from "../../../assets/icons/email-blue.svg";
import IconArrowLeftBlue from "../../../assets/icons/icon-arrow-left-blue.svg";
import IconVecotConnections from "../../../assets/icons/vector-connections.svg";
import IconArrowRight from "../../../assets/icons/arrow-down.svg";
import {
  IPeople,
  IPrevPeople,
  IStakeholder,
} from "../../../pages/StateInitiative/StateInitiative.type";
import {urlApiData} from "../../../helper/api";

const IMAGE_NONAME_SRC = "/mocks/no-name.png";

interface IProps {
  worker: IPeople;
  setIdWorkerShowConnections?: (id: string) => void;
  prevIdWorker?: IPrevPeople[];
  setPrevIdWorker?: (PrevPeople: IPrevPeople[]) => void;
}

const arrWorkerProperty = [
  {
    id: 1,
    title: "role",
    value: "Роль в инициативе",
    img: IconStarBlue,
  },
  {
    id: 2,
    title: "phoneNumber",
    value: "Телефон",
    img: IconPhoneBlue,
  },
  {
    id: 3,
    title: "email",
    value: "E-mail",
    img: IconEmailBlue,
  },
];

export const SidebarContentStateInitiativeWorker: FC<IProps> = ({
  worker,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
}) => {
  const handleShowConnections = (id: string) => {
    if (setIdWorkerShowConnections) setIdWorkerShowConnections(id);
  };
  if (!worker) {
    return null;
  }
  return (
    <div style={{color: "#fafafa"}}>
      {prevIdWorker?.length !== 0 && (
        <div
          onClick={() => {
            if (setIdWorkerShowConnections)
              setIdWorkerShowConnections(
                prevIdWorker?.[prevIdWorker.length - 1]?.documentId || ""
              );
            if (setPrevIdWorker)
              setPrevIdWorker(
                (prevIdWorker ?? []).slice(0, (prevIdWorker ?? []).length - 1)
              );
          }}
          style={{
            cursor: "pointer",
            color: "#57BCFF",
            fontSize: "14px",
            marginBottom: "10px",

            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img src={IconArrowLeftBlue} alt="Arrow" />
          {prevIdWorker?.[prevIdWorker.length - 1].fullName}
        </div>
      )}
      <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "50px",
              justifyContent: "end",
            }}
          >
            <img
              src={
                `${urlApiData}${worker.photo?.formats?.thumbnail?.url}` ||
                IMAGE_NONAME_SRC
              }
              alt={"man worker"}
              width="50"
              height="50"
              style={{borderRadius: "5px"}}
              onError={(e) => {
                e.currentTarget.src = IMAGE_NONAME_SRC;
              }}
            />
          </div>
          <div style={{display: "flex", flexDirection: "column"}}>
            <span style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 14}}>
              {worker.department}
            </span>
            <div style={{color: "#FAFAFA", fontSize: 20}}>
              {worker.fullName}
            </div>
            <span style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 14}}>
              {worker.role}
            </span>
          </div>
        </div>

        {arrWorkerProperty.map((item) => (
          <div
            key={item.id}
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              gap: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "50px",
                marginTop: "5px",
                justifyContent: "end",
              }}
            >
              <img
                src={item.img}
                alt={"man worker"}
                //   width="50"
                //   height="50"
                style={{borderRadius: "5px"}}
              />
            </div>
            <div style={{display: "flex", flexDirection: "column"}}>
              <span style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 16}}>
                {item.value}
              </span>
              <div style={{color: "#FAFAFA", fontSize: 14}}>
                {worker[item.title as keyof IPeople] as React.ReactNode}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{
            display: "flex",
            alignItems: "start",
            gap: "10px",
            marginTop: "30px",
            color: "rgba(255,255,255,0.6)",
          }}
        >
          <img
            src={IconVecotConnections}
            alt={"man worker"}
            width="25px"
            height="25px"
          />
          Векторы связей
        </div>
        {worker?.connections?.map((item, index) => (
          <div
            key={index}
            style={{
              color: "#FAFAFA",
              fontSize: 14,
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "12px",
              padding: "15px 10px",
            }}
          >
            <div
              style={{display: "flex", flexDirection: "column", gap: "10px"}}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "50px",
                    justifyContent: "end",
                  }}
                >
                  <img
                    src={
                      `${urlApiData}${item.photo?.formats?.thumbnail?.url}` ||
                      IMAGE_NONAME_SRC
                    }
                    alt={"man worker"}
                    width="50"
                    height="50"
                    style={{borderRadius: "5px"}}
                    onError={(e) => {
                      e.currentTarget.src = IMAGE_NONAME_SRC;
                    }}
                  />
                </div>
                <div style={{display: "flex", flexDirection: "column"}}>
                  <span
                    style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 14}}
                  >
                    {item.department}
                  </span>
                  <div style={{color: "#FAFAFA", fontSize: 20}}>
                    {item.fullName}
                  </div>
                  <span
                    style={{color: "rgba(255, 255, 255, 0.6)", fontSize: 14}}
                  >
                    {item.role}
                  </span>
                </div>
              </div>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px 16px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "16px",
                  marginLeft: "8px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "fit-content",
                  backgroundColor: "#22272B",
                }}
                onClick={() => {
                  handleShowConnections(item.documentId);
                  if (setPrevIdWorker)
                    setPrevIdWorker([
                      ...(prevIdWorker ?? []),
                      {
                        documentId: worker.documentId,
                        fullName: worker.fullName,
                      },
                    ]);
                }}
              >
                Показать связи
                <img
                  src={IconArrowRight}
                  alt="ArrowRight"
                  style={{transform: "rotate(-90deg)"}}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
